module.exports = __webpack_public_path__ + "static/img/MIR Story.12259fda.svg";